import React from 'react'
import CampaignPage from '../index'
import { PageWrapper } from '../../../../Components/Campaigns/Page/PageWrapper'
import InternalFilesContainer from './Container'

const InternalFiles = props => {
  return (
    <CampaignPage
      active={props.nav}
      campaignId={props.match.params.campaignId}
      history={props.history}
      match={props.match}
      location={props.location}
    >
      <PageWrapper>
        <InternalFilesContainer {...props} />
      </PageWrapper>
    </CampaignPage>
  )
}

export default InternalFiles
